<script>
import registrationBtn from "../ui/registrationBtn.vue";
import signBtn from "../ui/signBtn.vue";

export default {
    name: 'MainFooter',
    components: {
        registrationBtn,
        signBtn
    },
    data() {
        return {

        };
    },
    methods: {

    }
}
</script>


<template>
    <div class="footer">
        <div class="container">
            <div class="footer__content">
                <h2 class="footer__content-title">Новая эпоха в поиске<br>квалифицированных членов команды</h2>
                <router-link class="footer__logo" to=""><img class="footer__logo-image"
                        src="../../assets/image/logoBottom.svg" alt=""></router-link>
                <div class="footer__wrapper">
                    <div class="footer__wrapper-info">
                        <p class="footer__wrapper-text">Юридический адрес:<br><span>Пресненская наб., 12, Москва (офис №
                                777, этаж 77)</span></p>
                        <div class="footer__wrapper-links-wrapp">
                            <div class="footer__wrapper-links">
                                <a class="footer__wrapper-link"><img src="../../assets/image/call-add.svg"
                                        alt=""><div><span>8(800)</span> 555 66 80</div></a>
                                <a class="support-link" >Круглосуточная поддержка</a>
                            </div>
                            <div class="footer__wrapper-links">
                                <a class="footer__wrapper-link"><img src="../../assets/image/sms-tracking.svg"
                                        alt=""><div><span>info@</span>hrsetka.ru</div></a>
                                <a class="support-link" >Круглосуточная поддержка</a>
                            </div>
                        </div>
                        <div class="footer__wrapper-btns">
                            <registrationBtn />
                            <signBtn />
                        </div>
                        <div class="footer__copyright-wrapp">
                            <h4 class="footer__copyright-titke">ООО «Трансферплейс»</h4>
                            <p class="footer__copyright-text">ООО ««Трансферплейс»» обрабатывает пользовательские данные
                                при работе сайта в соответствии с <a >Политикой конфиденциальности</a>. <br>
                                Также Вы можете ознакомиться с <a >Политикой обработки персональных данных</a>.
                            </p>
                        </div>
                    </div>
                    <div class="footer__nav-wrapp">
                        <nav class="footer__nav">
                            <ul class="footer__nav-list">
                                <li class="footer__nav-item"><a class="footer__nav-link" >Главная</a></li>
                                <li class="footer__nav-item"><a class="footer__nav-link" >О компании</a></li>
                                <li class="footer__nav-item"><a class="footer__nav-link" >Услуги<img
                                            src="../../assets/image/arrow-down.svg" alt=""></a></li>
                                <li class="footer__nav-item"><a class="footer__nav-link" >Наши вакансии</a></li>
                                <li class="footer__nav-item"><a class="footer__nav-link" >Ростов-на-Дону<img
                                            src="../../assets/image/arrow-down.svg" alt=""></a></li>
                                <li class="footer__nav-item"><a class="footer__nav-link" >Чат с поддержкой</a>
                                </li>
                            </ul>
                        </nav>
                        <div class="logo-wrapp">
                            <img src="../../assets/image/logoRosstelecom.svg" alt="">
                            <img src="../../assets/image/logoWonderplace.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.footer {
    margin-bottom: 50px;
}
.footer__wrapper {
    display: flex;
    gap: 30px;
    margin-top: 40px;
}

.footer__wrapper-info {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.footer__wrapper-links-wrapp {
    display: flex;
    gap: 40px;
}

.footer__wrapper-info {
    flex: 1;
}

.footer__nav-wrapp {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.footer__nav-list {
    display: flex;
    flex-direction: column;
    gap: 40px;
    flex-wrap: wrap;
    max-height: 200px;
    max-width: 497px;
    
}

.logo-wrapp {
    display: flex;
    align-items: center;
    gap: 60px;
    margin-top: 149px;
    align-self: flex-end
}

.footer__content {
    border-radius: 100px;
    background-color: #1A1A1A;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 60px;
}

.footer__wrapper-links {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.footer__wrapper-text {
    color: #FFF;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.footer__wrapper-text span {
    color: #8D8D8D;
    font-family: Aeroport;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.footer__wrapper-btns {
    display: flex;
    gap: 10px;
}

.footer__content-title {
    color: #1A1A1A;
    text-align: center;
    font-family: Aeroport;
    font-size: 45px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -2.25px;
    height: 314px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url('../../assets/image/new-eraBackground.png') center no-repeat;
    background-size: cover;
    border-radius: 100px;
    margin-bottom: 40px;
}

.footer__wrapper-link {
    color: #FFF;
    font-family: Aeroport;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    gap: 10px;
}

.footer__wrapper-link span {
    font-weight: 300;
    font-size: 14px;
}

.support-link {
    color: #8D8D8D;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-decoration-line: underline;
}

.footer__copyright-wrapp {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer__copyright-titke {
    color: #FFF;
    font-family: Aeroport;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.footer__copyright-text {
    color: #8D8D8D;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 534px
}

.footer__copyright-text a {
    color: #8D8D8D;
    font-family: Aeroport;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
}

.footer__nav-link {
    color: #FFF;
    font-family: Aeroport;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    align-items: center;
    gap: 15px
}
@media (max-width: 991px) {
    .footer__content {
        padding: 20px 20px 30px;
        border-radius: 50px;
    }
    .footer__nav-link {
        font-size: 20px;
    }
    .footer__content-title {
        font-size: 35px;
    }
    .footer__content-title {
        border-radius: 50px;
    }
    .footer__wrapper {
        flex-direction: column;
    }
}
@media (max-width: 650px) {
    .footer {
        margin-bottom: 15px;
    }
    .footer__content-title {
        padding: 33px 15px 0;
        align-items: flex-start;
        height: 281px;
        background: url('../../assets/image/new-eraBackground-mob.png') center no-repeat;
        background-size: cover;
        margin-bottom: 30px;
        font-size: 25px;
    }
    .footer__logo-image {
        width: 153px;
    }
    .footer__wrapper {
        margin-top: 30px;
    }
    .footer__wrapper-text {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 11px;
    }
    .footer__wrapper-text span {
        font-size: 14px;
        display: block;
    }
    .footer__wrapper-info {
        gap: 30px;
    }
    .footer__wrapper-links-wrapp {
        flex-direction: column;
        gap: 20px;
    }
    .footer__wrapper-btns {
        gap: 13px;
        flex-wrap: wrap;
    }
    .footer__copyright-text {
        font-size: 12px;
    }
    .footer__nav-list {
        flex-direction: column;
        gap: 15px;
        max-height: max-content;
    }
    .logo-wrapp {
        margin-top: 30px;
        justify-content: flex-start;
        gap: 45px;
        align-self: flex-start;
    }
}
</style>